import React from "react";
import styles from "./MainImage.module.css";
import { handleImgError } from "../../Shared/ImageError";
function MainImage({ images, selectedImageIndex }) {
  return (
    <div className={styles.MainImage}>
      {images && images.length > 0 ? (
        <img
          src={images[selectedImageIndex].src}
          alt={images[selectedImageIndex].alt}
          onError={handleImgError}
        />
      ) : null}
    </div>
  );
}

export default MainImage;
